import React from 'react';
import { RegularButton, ArrowIcon } from 'fronton-react';
import { controlStyles, iconOnlyControlStyles } from 'common/components/products-carousel/styles';
import { useTranslation } from 'react-i18next';
import { cx } from 'linaria';

type Props = {
  onClick?: () => void;
  direction?: 'left' | 'right';
};

export const ProductsCarouselControl: React.FC<Props> = ({ direction = 'left', ...props }) => {
  const { t } = useTranslation();
  return (
    <RegularButton
      className={cx(controlStyles, iconOnlyControlStyles)}
      aria-label={direction === 'right' ? t('ui.carousel.next-slide') : t('ui.carousel.prev-slide')}
      rounded
      invert
      size="l"
      variant="primary"
      iconOnly={true}
      {...props}
    >
      <ArrowIcon direction={direction === 'right' ? 'right' : 'left'} />
    </RegularButton>
  );
};
